import { Action, IEventHandler, ofType } from '@bees-lite-web/core';
import { Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { KeeperAbstractService } from '../../services/keeper/keeper.abstract.service';
import { KeeperPayload } from '../../services/keeper/keeper.payload.interface';
import downloadFile from './download-file';

export class ResponseActionsDownloadFileHandler
  implements IEventHandler<KeeperPayload>
{
  constructor(private bffService: KeeperAbstractService) {}
  handler(
    source: Observable<Action<'response', KeeperPayload>>
  ): Observable<Action<'response', KeeperPayload>> {
    return source.pipe(
      ofType((e) => !!e.parameters?.action?.printFile),
      concatMap(async (e) => {
        const printFile = e.parameters?.action?.printFile;
        if (!printFile) {
          return e;
        }
        downloadFile(this.bffService, printFile);
        return e;
      })
    );
  }
}
